import { saveAs } from 'file-saver';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "../../../constants/appRoutes";
import { DateHelper } from "../../../helpers/dateHelper";
import { buildRegionizeRoute } from "../../../helpers/regionRouteHelper";
import { InitializeColumnsLoanTapeReport } from "../reportsColumn";
import { ReportsService } from "../reportsService";
import DataTableGrid from '../../../shared/formUtilities/useTable';

export const LoanTapeReport = () => {
  const reportsService = new ReportsService();
  const queryParameters = new URLSearchParams(window.location.search);
  const [loanTape, setLoanTape] = useState([]);
  const navigate = useNavigate();
  const [loading, setloading] = useState(false);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageCount: 0,
    perPage: 10,
    totalCount: 0,
  });
  const columns = InitializeColumnsLoanTapeReport();

  useEffect(() => {
    getLoanTapeReport();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryParameters.get('currentPage'), queryParameters.get('perPage')]);

  const getLoanTapeReport = () => {
    setloading(true);
    let currentPage = queryParameters.get('currentPage')
      ? parseInt(queryParameters.get('currentPage'))
      : 1;
    let perPage = queryParameters.get('perPage')
      ? parseInt(queryParameters.get('perPage'))
      : 10;
    reportsService
      .getLoanTapeReport(currentPage, perPage)
      .then((resp) => {
        setPagination({
          pageCount: resp.data.paging?.totalCount,
          currentPage: resp.data.paging?.currentPage,
          perPage: resp.data.paging?.perPage,
          totalCount: resp.data.paging?.totalCount,
        });
        setloading(false);
        setLoanTape(resp.data?.items);
      })
      .catch((err) => {
        setloading(false);
      });
  };

  function onNavigate(currentPage, perPage) {
    navigate({
      pathname: buildRegionizeRoute(`${AppRoutes.Reports}/${AppRoutes.ReportLoanTape}`),
      search: `?currentPage=${currentPage}&perPage=${perPage}`,
    });
  }

  const onPageSizeChange = (e) => {
    onNavigate(1, e);
  };

  const onPageChange = (e) => {
    onNavigate(e + 1, pagination.perPage);
  };

  const onDownloadCSV = () => {
    setloading(true);
    reportsService
      .exportLoanTapeReport()
      .then((resp) => {
        const date = DateHelper.formatDate(new Date());
        const fileName = `Loan-Tape-Report-${date}.csv`;
        saveAs(resp.data, fileName);
        setloading(false);
      })
      .catch((err) => {
        setloading(false);
      });
  };

  return (
    <>
      <DataTableGrid
        showDownloadCSV={true}
        download={() => {
          onDownloadCSV();
        }}
        name={'loanTapeReport'}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
        columns={columns}
        heading={'Loan Tape Report'}
        records={loanTape}
        pagination={pagination}
        showEditColumnsButton={true}
        loading={loading}></DataTableGrid>
    </>
  );
};
